import React from 'react';
import Search from "../../Search/Search";
import './userHeader.css';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';
import {
    currentSubscriptionAction,
    currentUserAction,
    dropdownAction,
    filterUsersAction,
    searchAction,
    userFormAction,
    usersListAction
} from "../../../redux/rootReducer";
import {
    exportUsersToExcelSagaAction,
    getUserInfoSagaAction,
    getUsersStatisticSagaAction
} from "../../../redux/sagaActions";
import { getUsersThunk } from "../../../redux/thunks/getUsersThunk";
import FiltersWrapper from "../../FiltersWrapper/FiltersWrapper";
import UsersFilter from "../../Filters/UsersFilter/UsersFilter";
import {
    CURRENT_SUBSCRIPTION_INITIAL,
    CURRENT_USER_INITIAL,
    FILTER_USERS_INITIAL,
    USER_FORM_INITIAL
} from "../../../redux/initialStateConstant";

const UsersHeader = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const users = useSelector(state => state.users);
    const dropdown = useSelector(state => state.dropdown);
    const currentUser = useSelector(state => state.currentUser);
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const usersList = useSelector(state => state.usersList);
    const filterUsers = useSelector(state => state.filterUsers);

    return (
        <>
            <div className="dropdown">
                <Search/>
                <div className={ `dropdown__items ${ dropdown === 'users' ? 'dropdown__items--open' : false }` }>
                    {
                        users?.length ? users.map(elem => {
                            return (
                                <div className="dropdown__item" key={ elem.id }
                                     onClick={ () => {
                                         dispatch(dropdownAction(null));
                                         // Добавляем id пользователя в адрес
                                         history.push('/fitness/users/' + elem.id);
                                         dispatch(getUserInfoSagaAction({ id: elem.id }));
                                         dispatch(searchAction(''));

                                     } }
                                >{ `${ elem.name } ${ elem.phone }` }</div>
                            );
                        })
                        : <div className="dropdown__item">{ `Нет результатов` }</div>
                    }
                </div>
            </div>
            <div className="user__right">
                {
                    currentUser.id
                        ?
                        <div className="user__back" onClick={ () => {
                            dispatch(currentUserAction(CURRENT_USER_INITIAL));
                            dispatch(currentSubscriptionAction(CURRENT_SUBSCRIPTION_INITIAL));
                            dispatch(searchAction(''));
                            dispatch(getUsersStatisticSagaAction({ establishment: currentEstablishment }));
                            // Удаляем id пользователя в адрес
                            history.push('/fitness/users');
                        } }>Назад</div>
                        : false
                }
                {
                    usersList.length
                        ?
                        <>
                            <div className="user__back"
                                 onClick={ () => dispatch(usersListAction([])) }
                            >Назад</div>
                            <div className="user__reports">
                                <FiltersWrapper>
                                    <UsersFilter/>
                                </FiltersWrapper>
                                <div className="user__report"
                                     onClick={ () => dispatch(exportUsersToExcelSagaAction({
                                         without_subscriptions: filterUsers.without_subscriptions,
                                         expire_to: filterUsers.expire_to,
                                         workouts_less_than: filterUsers.workouts_less_than,
                                         registration_not_later: filterUsers.registration_not_later,
                                         not_been_x_months: filterUsers.not_been_x_months,
                                         last_workout_from: filterUsers.last_workout_from,
                                         last_workout_to: filterUsers.last_workout_to,
                                         birthday_from: filterUsers.birthday_from,
                                         birthday_to: filterUsers.birthday_to,
                                         admin: filterUsers.admin,
                                         coach: filterUsers.coach,
                                         workouts_count: filterUsers.workouts_count,
                                         debt: filterUsers.debt,
                                         without_workouts: filterUsers.without_workouts
                                     })) }
                                >Сохранить в файл</div>
                            </div>
                        </>
                        : false
                }
                {
                    !usersList.length &&
                    <div className="user__all"
                         onClick={ () => {
                             // Сбрасываем фильтры пользователей
                             dispatch(filterUsersAction(FILTER_USERS_INITIAL));
                             dispatch(currentUserAction(CURRENT_USER_INITIAL));
                             dispatch(getUsersThunk({ page: 1 }));
                             // Удаляем id пользователя в адрес
                             history.push('/fitness/users');
                         } }
                    >Показать всех посетителей</div>
                }
                <div
                    className="button button--add"
                    onClick={ () => {
                        dispatch(userFormAction({
                            ...USER_FORM_INITIAL,
                            open: true,
                            title: 'Новый посетитель'
                        }));
                    } }
                >Добавить посетителя</div>
            </div>
        </>
    );
};

export default UsersHeader;